import { PropertyDefinitionOutputTypeEnum } from "src/clients/features-control";
import { Junction } from "src/eventsCatalogue/filters/types";

export const DEFAULT_JUNCTION: Junction = "and";

export const MAX_FILTER_GROUPS = 3;
export const MAX_CONDITIONS_PER_GROUP = 5;

export const JUNCTION_OPTIONS: Array<{ key: string; value: string }> = [
  { key: "and", value: "and" },
  { key: "or", value: "or" },
];

export const FILTERABLE_TYPES: PropertyDefinitionOutputTypeEnum[] = [
  PropertyDefinitionOutputTypeEnum.STRING,
  PropertyDefinitionOutputTypeEnum.BOOLEAN,
  PropertyDefinitionOutputTypeEnum.INTEGER,
  PropertyDefinitionOutputTypeEnum.NUMBER,
  PropertyDefinitionOutputTypeEnum.DATETIME,
  PropertyDefinitionOutputTypeEnum.DATE,
  PropertyDefinitionOutputTypeEnum.ENUM,
  PropertyDefinitionOutputTypeEnum.TAGS,
  PropertyDefinitionOutputTypeEnum.URL,
  PropertyDefinitionOutputTypeEnum.RELATION,
];

export const DEFAULT_FILTER_FORM_VALUES = {
  filter_condition: {
    conditions: [
      {
        junction: DEFAULT_JUNCTION,
        conditions: [
          {
            field: "",
            operator: "eq",
            value: "",
            junction: DEFAULT_JUNCTION,
          },
        ],
      },
    ],
  },
};
